import "./../../levels/common.blocks/logo/logo.react.js";
import _logo_type_link from "./../../levels/common.blocks/logo/_type/logo_type_link.react.js";

var Logo = _logo_type_link.applyDecls();

import "./../../levels/common.blocks/logo/logo.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-63x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-84x36.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-98x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-w-63x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-w-84x36.css";
import "./../../levels/common.blocks/logo/_name/logo_name_en-w-98x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-63x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-84x36.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-98x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-w-63x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-w-84x36.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ru-w-98x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-102x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-66x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-69x28.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-84x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-87x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-w-102x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-w-66x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-w-69x28.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-w-84x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-en-w-87x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-64x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-69x28.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-84x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-86x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-98x42.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-w-64x27.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-w-69x28.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-w-84x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-w-86x35.css";
import "./../../levels/common.blocks/logo/_name/logo_name_ys-ru-w-98x42.css";
import "./../../levels/common.blocks/logo/_type/logo_type_link.css"; // eslint-disable-line

export default Logo;